import { FilterCount } from "@flights/search-ui";
import React, { FC } from "react";
import { InputCheckbox, Stack, Text } from "@bookingcom/bui-react";
import { useFlightTimesFilterController } from "./useFlightTimesFilter.controller";
import flights_web_budget_layover_airports_filters from "../../../../../utils/experiments/funnel/flights_web_budget_layover_airports_filters";

export const OptionsList: FC<{ optionIndex: number }> = ({ optionIndex }) => {
  const { isFilterAvailable, options, onChange } = useFlightTimesFilterController();
  const { departure, arrival, labels } = options[optionIndex];
  if (!isFilterAvailable) return null;

  const addNewFilters = !!flights_web_budget_layover_airports_filters.trackWithDefaultStage();

  return (
    <Stack gap={4}>
      {/* Departure */}
      <Stack.Item>
        <Stack gap={2}>
          <Text
            variant="emphasized_2"
            tagName={addNewFilters ? "h4" : labels.tagName}
            attributes={{
              "data-testid": "flight_times_filter_v2_departure_label",
              id: "flight_times_filter_v2_departure_label"
            }}
          >
            {labels.departure}
          </Text>

          <div role="group" aria-labelledby="flight_times_filter_v2_departure_label">
            <Stack gap={2}>
              {departure.map(({ count, disabled, label, checked, name }, timeIndex) => (
                <FilterCount
                  key={`departure-${label}`}
                  count={count}
                  attributes={{ "data-testid": `flight_times_filter_v2_flight_time_departure_${timeIndex}_count` }}
                >
                  <InputCheckbox
                    disabled={disabled}
                    label={label}
                    checked={checked}
                    name={name}
                    attributes={{
                      "data-testid": `flight_times_filter_v2_flight_time_departure_${timeIndex}`
                    }}
                    onChange={({ checked }) => onChange({ type: "departure", checked, optionIndex, timeIndex })}
                  />
                </FilterCount>
              ))}
            </Stack>
          </div>
        </Stack>
      </Stack.Item>

      {/* Arrival */}
      <Stack.Item>
        <Stack gap={2}>
          <Text
            variant="emphasized_2"
            tagName={addNewFilters ? "h4" : labels.tagName}
            attributes={{
              "data-testid": "flight_times_filter_v2_arrival_label",
              id: "flight_times_filter_v2_arrival_label"
            }}
          >
            {labels.arrival}
          </Text>

          <div role="group" aria-labelledby="flight_times_filter_v2_arrival_label">
            <Stack gap={2}>
              {arrival.map(({ count, disabled, label, checked, name }, timeIndex) => (
                <FilterCount
                  key={`arrival-${label}`}
                  count={count}
                  attributes={{ "data-testid": `flight_times_filter_v2_flight_time_arrival_${timeIndex}_count` }}
                >
                  <InputCheckbox
                    disabled={disabled}
                    label={label}
                    checked={checked}
                    name={name}
                    attributes={{ "data-testid": `flight_times_filter_v2_flight_time_arrival_${timeIndex}` }}
                    onChange={({ checked }) => onChange({ type: "arrival", checked, optionIndex, timeIndex })}
                  />
                </FilterCount>
              ))}
            </Stack>
          </div>
        </Stack>
      </Stack.Item>
    </Stack>
  );
};
